import { useState } from "react";
import {
  Box,
  Typography,
  Button,
  Grid,
  Stack,
  IconButton,
} from "@mui/material";

export default function Banner() {
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState("");

  const handleStartConversation = () => {
    const url = `https://eternity.ac/dc/mariya`;
    setIframeUrl(url);
    setShowIframe(true);
  };

  const handleContactClick = () => {
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleCloseIframe = () => {
    setShowIframe(false);
    setIframeUrl("");
  };

  if (showIframe) {
    return (
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100vh",
          bgcolor: "#f5f5f5",
          marginTop: {
            xs: "65px",
            md: 0,
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: 10,
            right: 10,
            zIndex: 1000,
          }}
        >
          <IconButton
            onClick={handleCloseIframe}
            sx={{
              bgcolor: "rgba(0,0,0,0.7)",
              padding: "6px 10px",
              color: "white",
              "&:hover": {
                bgcolor: "rgba(0,0,0,0.9)",
              },
            }}
          >
            ✕
          </IconButton>
        </Box>
        <Box
          component="iframe"
          src={iframeUrl}
          sx={{
            width: "100%",
            height: "100%",
            border: "none",
            borderRadius: 0,
          }}
          title="Digital Clone Chat"
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "relative",
        py: { xs: 2, md: 8 },
        pt: { xs: "80px", lg: 2 },
        px: 0,
        backgroundImage: `url(/images/home/main-banner.jpg)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        height: { xs: "auto", md: "70vh" },
        minHeight: { xs: "auto", md: "70vh" },
        display: "flex",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "100%", px: 0 }}>
        <Box
          sx={{
            display: { xs: "block", md: "none" },
            textAlign: "center",
            mb: { md: 4 },
            px: 4,
          }}
        >
          <Typography
            variant="h2"
            fontWeight="bold"
            gutterBottom
            sx={{
              fontSize: "32px",
              color: "#333",
              mb: 2,
              lineHeight: 1.2,
            }}
          >
            AI-powered Digital Clone
          </Typography>

          <Typography
            variant="h6"
            paragraph
            sx={{
              fontSize: "16px",
              color: "#666",
              mb: 3,
              fontWeight: 400,
            }}
          >
            For business
          </Typography>

          <Box
            sx={{
              width: 300,
              height: 300,
              borderRadius: "50%",
              overflow: "hidden",
              mb: 3,
              boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
              border: "3px solid rgba(255, 255, 255, 0.8)",
              mx: "auto",
            }}
          >
            <Box
              component="img"
              src="/images/home/main-banner-avatar-image-c2.png"
              alt="Avatar"
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </Box>
        </Box>

        <Grid container alignItems="center" spacing={0}>
          <Grid
            size={{ xs: 12, md: 7 }}
            sx={{ display: { xs: "none", md: "flex" } }}
          >
            <Box
              sx={{
                backdropFilter: { xs: "none", md: "blur(20px)" },
                background: {
                  xs: "transparent",
                  md: "rgba(255, 255, 255, 0.3)",
                },
                borderRadius: { xs: 0, md: "0 16px 16px 0" },
                p: { xs: 4, md: 5 },
                pl: { xs: 4, md: 20 },
                textAlign: { xs: "center", md: "left" },
                boxShadow: { xs: "none", md: "0 8px 32px rgba(0, 0, 0, 0.1)" },
                width: { xs: "100%", md: "80%" },
                ml: 0,
                mr: "auto",
                minHeight: { xs: "auto", md: "50vh" },
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: { xs: "center", md: "flex-start" },
              }}
            >
              <Typography
                variant="h2"
                fontWeight="bold"
                gutterBottom
                sx={{
                  fontSize: { xs: "32px", sm: "40px", md: "48px" },
                  color: "#333",
                  mb: { xs: 2, md: 2 },
                  lineHeight: 1.2,
                  display: { xs: "none", md: "block" },
                }}
              >
                AI-powered Digital Clone
              </Typography>

              <Typography
                variant="h6"
                paragraph
                sx={{
                  fontSize: { xs: "16px", sm: "17.6px", md: "19.2px" },
                  color: "#666",
                  mb: { xs: 3, md: 3 },
                  fontWeight: 400,
                  display: { xs: "none", md: "block" },
                }}
              >
                For business
              </Typography>

              <Button
                variant="contained"
                size="large"
                sx={{
                  bgcolor: "#5C78FF",
                  borderRadius: "30px",
                  px: { xs: 3, md: 4 },
                  py: { xs: 1.2, md: 1.5 },
                  fontSize: { xs: "14px", md: "16px" },
                  fontWeight: "600",
                  textTransform: "none",
                  mb: { xs: 3, md: 4 },
                  boxShadow: "0 4px 15px rgba(92, 120, 255, 0.3)",
                  display: { xs: "none", md: "inline-flex" },
                  "&:hover": {
                    bgcolor: "#4660c8",
                    boxShadow: "0 6px 20px rgba(92, 120, 255, 0.4)",
                  },
                }}
                onClick={handleContactClick}
              >
                Try for free
              </Button>

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                alignItems="center"
                sx={{
                  justifyContent: { xs: "center", md: "flex-start" },
                  display: { xs: "none", md: "flex" },
                }}
              >
                <Typography
                  variant="body1"
                  fontWeight={500}
                  sx={{
                    color: "#333",
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: "800",
                  }}
                >
                  Integration with
                </Typography>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Box
                    component="img"
                    src="/images/logos/salesforce-logo.svg"
                    sx={{ height: { xs: 50, md: 60 } }}
                    alt="Salesforce"
                    title="Salesforce"
                  />
                  <Box
                    component="img"
                    src="/images/logos/HubSpot_Logo.svg"
                    sx={{ height: { xs: 17, md: 20 } }}
                    alt="HubSpot"
                    title="HubSpot"
                  />
                </Stack>
              </Stack>

              <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={2}
                marginTop={1}
                alignItems="center"
                sx={{
                  justifyContent: { xs: "center", md: "flex-start" },
                  display: { xs: "none", md: "flex" },
                }}
              >
                <Typography
                  variant="body1"
                  fontWeight={500}
                  sx={{
                    color: "#333",
                    fontSize: { xs: "14px", md: "16px" },
                    fontWeight: "800",
                  }}
                >
                  Powered by
                </Typography>
                <Stack direction="row" spacing={2} alignItems="center">
                  <Box
                    component="img"
                    src="/images/logos/eternity-logo-black.svg"
                    sx={{ height: { xs: 17, md: 20 } }}
                    alt="eternity ac"
                    title="eternity ac"
                  />
                </Stack>
              </Stack>
            </Box>
          </Grid>

          <Grid
            size={{ xs: 12, md: 5 }}
            sx={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                mt: { xs: 4, md: 0 },
              }}
            >
              <Box
                sx={{
                  width: { xs: 150, sm: 200, md: 280 },
                  height: { xs: 150, sm: 200, md: 280 },
                  borderRadius: "50%",
                  overflow: "hidden",
                  mb: { xs: 2, md: 3 },
                  boxShadow: "0 20px 40px rgba(0, 0, 0, 0.15)",
                  border: "3px solid rgba(255, 255, 255, 0.8)",
                  display: { xs: "none", md: "block" },
                }}
              >
                <Box
                  component="img"
                  src="/images/home/main-banner-avatar-image-c2.png"
                  alt="Avatar"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </Box>

              <Box
                sx={{
                  width: "100%",
                  maxWidth: { xs: "90%", sm: 350, md: 500 },
                  position: "relative",
                  px: { xs: 0, md: 0 },
                }}
              >
                <Box
                  sx={{
                    background: "#fff",
                    borderRadius: "24px",
                    py: { xs: 1.5, md: 2 },
                    px: { xs: 2.5, md: 3 },
                    fontWeight: 500,
                    fontSize: { xs: "14px", md: "16px" },
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                    textAlign: "left",
                    mb: { xs: 1.5, md: 2 },
                    color: "#333",
                    position: "relative",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      bottom: -8,
                      left: { xs: 25, md: 30 },
                      width: 0,
                      height: 0,
                      borderLeft: "10px solid transparent",
                      borderRight: "10px solid transparent",
                      borderTop: "10px solid #fff",
                    },
                  }}
                  onClick={handleStartConversation}
                >
                  Hi! I'm Maria. Would you like me to tell you about our
                  product? Click here to start.
                </Box>
                <Box
                  sx={{
                    mt: { xs: 3, md: 0 },
                    display: { xs: "flex", md: "none" },
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    size="large"
                    sx={{
                      bgcolor: "#5C78FF",
                      borderRadius: "30px",
                      px: 4,
                      py: 1.5,
                      fontSize: "16px",
                      fontWeight: "600",
                      textTransform: "none",
                      mb: 3,
                      boxShadow: "0 4px 15px rgba(92, 120, 255, 0.3)",
                      "&:hover": {
                        bgcolor: "#4660c8",
                        boxShadow: "0 6px 20px rgba(92, 120, 255, 0.4)",
                      },
                    }}
                    onClick={handleContactClick}
                  >
                    Try for free
                  </Button>

                  <Stack
                    direction="row"
                    spacing={2}
                    alignItems="center"
                    sx={{ mb: 2 }}
                  >
                    <Typography
                      variant="body1"
                      fontWeight={500}
                      sx={{
                        color: "#333",
                        fontSize: "14px",
                        fontWeight: "800",
                      }}
                    >
                      Integration with
                    </Typography>
                    <Box
                      component="img"
                      src="/images/logos/salesforce-logo.svg"
                      sx={{ height: 50 }}
                      alt="Salesforce"
                      title="Salesforce"
                    />
                    <Box
                      component="img"
                      src="/images/logos/HubSpot_Logo.svg"
                      sx={{ height: 17 }}
                      alt="HubSpot"
                      title="HubSpot"
                    />
                  </Stack>

                  <Stack direction="row" spacing={2} alignItems="center">
                    <Typography
                      variant="body1"
                      fontWeight={500}
                      sx={{
                        color: "#333",
                        fontSize: "14px",
                        fontWeight: "800",
                      }}
                    >
                      Powered by
                    </Typography>
                    <Box
                      component="img"
                      src="/images/logos/eternity-logo-black.svg"
                      sx={{ height: 17 }}
                      alt="eternity ac"
                      title="eternity ac"
                    />
                  </Stack>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
